import * as React from 'react';
import * as _ from 'underscore';

export const ThumbnailImage: React.StatelessComponent<ThumbnailImage.Props> = function ThumbnailImage(props: ThumbnailImage.Props) {
  return React.createElement('div', {
    className: props.className,

    style: _.extend({
      backgroundImage: 'url(' + encodeURI(props.url) + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'top',
      backgroundRepeat: 'no-repeat'
    }, props.style),
    'data-tb-test-id': props.tbTestId
  } as React.HTMLAttributes<HTMLDivElement>);
};

export namespace ThumbnailImage {
  export interface Props {
    url: string;
    tbTestId: string;
    style?: React.CSSProperties;
    className?: string;
  }
}
